import { Typography } from "matsuri-ui"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useMemo } from "react"
import { InfoSection } from "../InfoSection"
import { PositionOfGarbageDumpFormPrivateLodgingAndKeyNumber } from "./PositionOfGarbageDumpFormPrivateLodgingAndKeyNumber"
import { extractRoomGarbageInfo } from "@/model/bigQueryInfo"
import { useListingBigQueryTable } from "@/hooks/useListingBigQueryTable"
import { useTranslation } from "@/hooks/useTranslation"

export const RoomGarbageInfo = ({ operationId }: { operationId: string }) => {
    const { token } = useAuth()
    const { data: listingBigQueryTable } = useListingBigQueryTable(
        token,
        operationId
    )

    const { t } = useTranslation()
    const roomGarbageInfo = useMemo(() => {
        return extractRoomGarbageInfo(listingBigQueryTable?.rows ?? [])
    }, [listingBigQueryTable?.rows])

    return (
        <InfoSection>
            <Typography variant="h4" bolder>
                {t("ゴミ庫情報")}
            </Typography>

            <div>
                <Typography bolder>{t("一般ゴミ捨て場の位置")}</Typography>
                <PositionOfGarbageDumpFormPrivateLodgingAndKeyNumber
                    value={roomGarbageInfo?.position_of_general_garbage_dump}
                />
            </div>

            <div>
                <Typography bolder>
                    {t("民泊用ゴミ捨て場の位置と南京錠の番号")}
                </Typography>
                <PositionOfGarbageDumpFormPrivateLodgingAndKeyNumber
                    value={
                        roomGarbageInfo?.position_of_garbage_dump_for_private_lodging_and_key_number
                    }
                />
            </div>
        </InfoSection>
    )
}
